var exports = {
  "x6": "MemberListItem.module__button___TnNBcF",
  "OG": "MemberListItem.module__nameRoleColored___TnNBcF",
  "w1": "MemberListItem.module__buttonOffline___TnNBcF",
  "dP": "MemberListItem.module__buttonContextMenuOpen___TnNBcF",
  "vs": "MemberListItem.module__memberFocusRing___TnNBcF",
  "Vg": "MemberListItem.module__grid___TnNBcF",
  "Qs": "MemberListItem.module__content___TnNBcF",
  "H": "MemberListItem.module__avatarContainer___TnNBcF",
  "TT": "MemberListItem.module__userInfoContainer___TnNBcF",
  "VW": "MemberListItem.module__nameContainer___TnNBcF",
  "UU": "MemberListItem.module__name___TnNBcF",
  "w4": "MemberListItem.module__memberCustomStatus___TnNBcF",
  "Dd": "MemberListItem.module__ownerIcon___TnNBcF",
  "j$": "MemberListItem.module__crownIcon___TnNBcF",
  "a1": "MemberListItem.module__userTag___TnNBcF",
};

module.exports = exports;
